import { SelectField } from '@hypeit-gmbh/hypeit-ui';
import { Group, Input, Text } from '@mantine/core';
import { FieldValues, Path } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const HOURS = Array.from({ length: 24 }, (_, hour) =>
  String(hour).padStart(2, '0')
);
const MINUTES = ['00', '15', '30', '45'];

type SendTimePropsType<T extends FieldValues> = {
  hourFieldName: Path<T>;
  minuteFieldName: Path<T>;
};

export const SendTime = <T extends FieldValues>({
  hourFieldName,
  minuteFieldName,
}: SendTimePropsType<T>): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <Input.Wrapper label={t('REPORTS.MAILING_FORM.SEND_TIME')}>
      <Group gap="xs">
        <SelectField<T>
          fieldName={hourFieldName}
          aria-label={t('REPORTS.MAILING_FORM.SEND_HOUR')}
          data={HOURS}
          allowDeselect={false}
          w={80}
        />
        <Text>:</Text>
        <SelectField<T>
          fieldName={minuteFieldName}
          aria-label={t('REPORTS.MAILING_FORM.SEND_MINUTE')}
          data={MINUTES}
          allowDeselect={false}
          w={80}
        />
      </Group>
    </Input.Wrapper>
  );
};
